import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectCore = _resolveComponent("SelectCore")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_ctx.generalMethods.valueExist(_ctx.prop))
    ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: _ctx.hideLabel ? null : _ctx.generalMethods.translate(_ctx.label),
        for: _ctx.id == null ? _ctx.prop : _ctx.id,
        prop: _ctx.prop,
        rules: _ctx.rules,
        class: _normalizeClass(`${_ctx.elFormItemClassses}`),
        "label-width": "100px",
        required: _ctx.required
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectCore, {
            id: _ctx.id == null ? _ctx.prop : _ctx.id,
            modelValue: _ctx.localModelValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localModelValue) = $event)),
            options: _ctx.options,
            optionEnglishArabicName: _ctx.optionEnglishArabicName,
            "value-key": _ctx.valueKey,
            onChange: _cache[1] || (_cache[1] = (value) => _ctx.emitEvent('change', value)),
            disabled: _ctx.disabled,
            readonly: _ctx.readonly,
            placeholder: _ctx.generalMethods.translate(_ctx.placeholder),
            size: _ctx.size,
            teleported: false,
            class: _normalizeClass(_ctx.elClasses),
            clearable: _ctx.clearable,
            multiple: _ctx.multiple
          }, null, 8, ["id", "modelValue", "options", "optionEnglishArabicName", "value-key", "disabled", "readonly", "placeholder", "size", "class", "clearable", "multiple"])
        ]),
        _: 1
      }, 8, ["label", "for", "prop", "rules", "class", "required"]))
    : (_openBlock(), _createBlock(_component_SelectCore, {
        key: 1,
        id: _ctx.id == null ? _ctx.prop : _ctx.id,
        modelValue: _ctx.localModelValue,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModelValue) = $event)),
        options: _ctx.options,
        optionEnglishArabicName: _ctx.optionEnglishArabicName,
        "value-key": _ctx.valueKey,
        onChange: _cache[3] || (_cache[3] = (value) => _ctx.emitEvent('change', value)),
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        placeholder: _ctx.generalMethods.translate(_ctx.placeholder),
        size: _ctx.size,
        teleported: false,
        class: _normalizeClass(_ctx.elClasses),
        clearable: _ctx.clearable,
        multiple: _ctx.multiple
      }, null, 8, ["id", "modelValue", "options", "optionEnglishArabicName", "value-key", "disabled", "readonly", "placeholder", "size", "class", "clearable", "multiple"]))
}